<app-logo-header></app-logo-header>
<section class="section" style="height: 80vh;">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-10 col-lg-8">
        <!-- card -->
        <div class="card px-0 my-3">
          <div class="card-header">
            <h3 class="pt-2 text-primary">
              {{'Login.ForgotPassword' |translate}}
            </h3>
          </div>
          <div class="card-body p-3">
            <div class="row">
              <div class="col-12">
                <form *ngIf="forgotForm"
                      [formGroup]="forgotForm"
                      class="align-items-center"
                      novalidate="novalidate">
                  <div class="row">
                    <div class="col-12">
                      <div class="form-group" *ngIf="!submitted">
                        <label class="text-muted" for="account-email">
                          {{'Login.EnterEmail' |translate}}
                        </label>
                        <input formControlName="email" id="login-email"
                               class="form-control w-100 mt-2" type="email"
                               placeholder="example@domain.com" autocomplete="off" />
                        <p class="text-danger" *ngIf="formValidator?.formErrors?.email">
                          {{formValidator.formErrors.email}}
                        </p>
                      </div>
                      <h4 class="pt-2" *ngIf="submitted">
                        {{'Login.AnEmailSentTo' |translate}} <span class="text-primary">{{ forgotForm.value.email }}</span>
                      </h4>
                    </div>
                  </div>

                  <!-- login__actions -->
                  <div class="row align-content-center mt-3">
                    <div class="col-auto my-1" [ngClass]="submitted ? 'ms-auto' : 'me-auto'">
                      <a routerLink="/login" class="btn btn-outline-primary">
                        {{'Login.ReturnToLogin' |translate}}
                      </a>
                    </div>
                    <div class="col-auto ms-auto my-1" *ngIf="!submitted">
                      <button class="btn btn-primary" type="submit"
                              (click)="onSubmit()" [disabled]="!forgotForm.valid">
                              {{'Login.SendResetLink' |translate}}
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<recaptcha
[size]="'invisible'"
[hide]="false"
>
</recaptcha>

<app-footer></app-footer>
